import { DefaultProjectRedirect } from '~/components/redirect/DefaultProjectRedirect';

export default function EnvironmentsRedirect() {
  return <DefaultProjectRedirect targetPath="environments" />;
}
